import Vuex from "vuex"
import Vue from "vue"
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      showoption: false,
      modellis:'',
      imginfo:'',
      indexx:'',
      registype:null,
      country:'',
      ishowpay:false,
      errorcode:'',
      //显示app下载按钮
      showapp:true,
      //paypal的按钮初始化
      PayBtnInitOver:false,
      titles:'',
      //显示隐藏 sharebox
      isshare:true,
      refereeid:'',
      index_scroller_position:'',
      model_scroller_position:'',
      share_url:'',
    },
    modules:{
      underhomepage2:{
        state:{
            arr:'',
            imginfo:'',
            swili:'',
          }
      },
      photo:{
        state:{
          list:'',
          tagid:'',
        }
      },
      switchlist:{
        whichs:'',
      }
    },
    mutations: {
      changeshow () {
        this.state.showoption=!this.state.showoption;
      },
      initPicInfo () {
        this.state.underhomepage2.imginfo='';
      }
    }
  });
  export default store;


// WEBPACK FOOTER //
// ./src/store/homepage.js